var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarterlabsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "163.2%",
    height: "163.2%",
    x: "-31.6%",
    y: "-31.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.988235294 0 0 0 0 0.839215686 0 0 0 0 0.482352941 0 0 0 0.8 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "160.2%",
    height: "160.2%",
    x: "-30.1%",
    y: "-21.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1 0 0 0 0 0.907774932 0 0 0 0 0.661841416 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "-13.551%",
    y2: "69.75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEEBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCD372"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 23.75,
    cy: 23.75,
    r: 23.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0.631100369,14.0266888 C1.65024431,16.9354955 2.9454064,20.5874279 6.51241019,22.3072333 C10.4191286,24.1968961 15.5148483,23.0928235 18.6572088,20.3326419 C23.5193747,16.0649767 25.0268585,7.9542895 20.6954967,3.70785642 C14.835419,-2.00359609 4.176872,-0.77213049 0.928350685,5.04548284 C-0.196954083,7.06253855 -0.30311491,11.3726681 0.631100369,14.0266888 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#000",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.898 11.422)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .214)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#000",
    filter: "url(#e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.461)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB6361",
    d: "M7.87713338,19.5061425 L0,23.6888791 L4.18273659,15.8117457 C5.01079104,14.2405655 7.11277542,13.7522257 8.47163401,14.8987626 C8.5353305,14.9412269 8.599027,15.0049234 8.64149133,15.0686199 C8.70518783,15.1323164 8.74765216,15.1747808 8.81134865,15.2384773 C9.93665342,16.5761037 9.44831362,18.6568559 7.87713338,19.5061425 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBBD63",
    d: "M8.1106872,17.7438728 L3.46084297,20.206804 L5.92377416,15.5569597 C6.41211396,14.6227445 7.64357956,14.3467263 8.45040184,15.0261556 C8.49286617,15.0473878 8.51409834,15.0898521 8.55656267,15.1110843 C8.599027,15.1323164 8.62025917,15.1747808 8.64149133,15.2172451 C9.34215279,16.0240674 9.04490247,17.255533 8.1106872,17.7438728 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4F53",
    d: "M9.38461712 8.61404164C9.38461712 8.61404164 5.62652384 7.97707668 3.22728915 11.7139378 3.22728915 11.7139378 3.03619966 12.1810454 3.67316462 12.1598133 3.67316462 12.1598133 6.24225664 11.480384 7.62234739 12.3296706 7.62234739 12.3296706 8.19561586 10.5461687 9.38461712 8.61404164ZM15.1173018 14.3467263C15.1173018 14.3467263 15.7542668 18.1048196 12.0174056 20.5040543 12.0174056 20.5040543 11.550298 20.6951438 11.5715302 20.0581788 11.5715302 20.0581788 12.2509595 17.4890868 11.4016728 16.108996 11.4016728 16.108996 13.1851747 15.5357276 15.1173018 14.3467263Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83D6DE",
    d: "M23.610168,1.60742705 C23.7800253,0.885533421 23.6314001,0.439657947 23.4190785,0.248568458 C23.227989,0.0362468034 22.7821135,-0.0911461892 22.0602199,0.0787111343 C22.0602199,0.0787111343 11.8900126,1.58619488 7.64357956,11.6502413 C7.34632924,12.3509028 7.51618656,13.2214215 8.06822286,13.79469 L8.95997381,14.686441 L9.87295693,15.5994241 C10.4249932,16.1514604 11.3167442,16.3213177 11.9961735,16.0240674 C22.1026842,11.7776343 23.610168,1.60742705 23.610168,1.60742705 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.635,
    cy: 13.981,
    fill: "#777",
    rx: 3.631,
    ry: 1,
    transform: "rotate(-45 9.635 13.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.795,
    cy: 6.873,
    r: 2.803,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.795,
    cy: 6.873,
    r: 2.102,
    fill: "#FC7A7A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.795,
    cy: 6.13,
    r: 1,
    fill: "#FFB6B6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterlabsIcon);
export default __webpack_public_path__ + "static/media/Starterlabs-icon.f70c5f4efd00c35ac00ca74262fb1dd0.svg";
export { ForwardRef as ReactComponent };